import React, { useEffect, useState } from 'react'
import { IDonatesListAnswer, getDonates as getDonatesAPIFunction } from '../../api/donate'
import { Spin } from 'antd'
import { DonateCard } from './DonateCard'

export const Donates = (): React.ReactElement => {
	const [answer, setAnswer] = useState<IDonatesListAnswer>({
		donates: [],
		message: '',
		success: false
	})

	const [loading, setIsLoading] = useState(true)

	const getDonates = async () => {
		setAnswer(await getDonatesAPIFunction())
		setIsLoading(false)
	}

	useEffect(() => {
	    void getDonates()
	}, [])

	if (loading) {
		return (
			<Spin style={{ marginTop: '5%' }}/>
		)
	}
	return (
		<div style={{
		    padding: '2%',
			display: 'grid',
			justifyContent: 'center',
			gridTemplateColumns: 'repeat(auto-fill, 280px)',
			gridGap: 15
		}}>
			{answer.success ? (
				answer.donates.map(
				    (donate, index) =>
						<DonateCard donate={donate} key={index}/>
				)
			) : <></>}
		</div>
	)

}

export const routePathDonates = '/donates'
